import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import { useHistory } from 'react-router-dom'
import { Tooltip, Button } from '@material-ui/core'
import { ArrowLeft as ArrowLeftIcon } from 'react-feather'

import { routes } from 'Routes'
import useStyles from './styles'

const BackToSteps = ({ showBackToFirstSteps }) => {
  const classes = useStyles()
  const history = useHistory()
  const nodeRef = useRef(null)

  const handleBackToUserSteps = () => history.push(routes.userSteps)

  return (
    <CSSTransition
      in={showBackToFirstSteps}
      nodeRef={nodeRef}
      timeout={300}
      classNames={{
        enter: classes.transitionEnter,
        enterActive: classes.transitionEnterActive,
        exit: classes.transitionExit,
        exitActive: classes.transitionExitActive,
      }}
      unmountOnExit
    >
      <Tooltip ref={nodeRef} title="Voltar para o módulo de primeiro acesso">
        <Button
          size="large"
          className={classes.buttonBackToSteps}
          onClick={handleBackToUserSteps}
          startIcon={<ArrowLeftIcon />}
        >
          Voltar para o primeiro acesso
        </Button>
      </Tooltip>
    </CSSTransition>
  )
}

BackToSteps.propTypes = {
  showBackToFirstSteps: PropTypes.bool.isRequired,
}

export default BackToSteps
